module.exports = __webpack_public_path__ + "8177ee440825880c7089c9f828d009bb.fbx";